var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    style: {
      fill: "#00933b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.464 56.36c.37 2.019 1.074 3.576 2.116 4.672 1.042 1.096 2.56 1.644 4.557 1.644 2.3 0 4.053-.809 5.258-2.425 1.204-1.617 1.806-3.652 1.806-6.104 0-2.409-.564-4.443-1.693-6.103-1.128-1.66-2.886-2.49-5.273-2.49-1.128 0-2.105.14-2.93.423-1.454.52-2.55 1.486-3.287 2.897l-8.334-.39 3.32-26.075h26.01v7.878H39.71l-1.692 10.319c1.432-.934 2.55-1.552 3.352-1.856 1.346-.5 2.984-.749 4.916-.749 3.906 0 7.313 1.313 10.221 3.94 2.908 2.625 4.362 6.444 4.362 11.457 0 4.362-1.4 8.258-4.2 11.687-2.799 3.428-6.987 5.143-12.564 5.143-4.492 0-8.182-1.205-11.068-3.613-2.886-2.41-4.492-5.827-4.818-10.254h9.245Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.6829af1bb54c4b9dc1838eed08ac7f0d.svg";
export { ForwardRef as ReactComponent };